export default __webpack_public_path__ + "static/advent-calendar-explorer-ef067f11b5a581849546e1916a2dcba6.png";